var _path, _rect, _path2, _path3, _path4, _circle, _circle2, _line, _path5, _path6, _path7, _path8, _circle3, _path9, _path10, _rect2, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 196,
    viewBox: "0 0 409 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.486 86.8687V117.363H111.655V146.854H76.005V117.363H0.5V92.8252L67.5878 2.40744H106.574L45.2884 86.8687H77.0064V60.5874H111.655V86.8687H134.486ZM79.0092 88.8749H41.3568L102.642 4.41364H68.5947L2.50278 93.4892V115.357H78.0078V144.848H109.652V115.357H132.483V88.8749H109.652V62.5936H79.0092V88.8749ZM157.799 129.637C146.696 116.826 140.185 98.1641 140.185 74.6308C140.185 51.0976 146.696 32.4352 157.799 19.6245C168.921 6.79145 184.509 0 202.271 0C220.131 0 235.721 6.78984 246.82 19.6263C257.898 32.4387 264.357 51.1015 264.357 74.6308C264.357 98.1601 257.898 116.823 246.82 129.635C235.721 142.472 220.131 149.262 202.271 149.262C184.509 149.262 168.921 142.47 157.799 129.637ZM220.405 108.054C224.925 101.226 227.706 90.3984 227.706 74.6308C227.706 58.8633 224.925 48.0356 220.405 41.2079C215.964 34.5012 209.748 31.4974 202.271 31.4974C194.903 31.4974 188.735 34.4939 184.316 41.2039C179.817 48.0336 177.036 58.8639 177.036 74.6308C177.036 90.3977 179.817 101.228 184.316 108.058C188.735 114.768 194.903 117.764 202.271 117.764C209.748 117.764 215.964 114.76 220.405 108.054ZM408.5 86.8687V117.363H385.668V146.854H350.019V117.363H274.514V92.8252L341.602 2.40744H380.587L319.302 86.8687H351.02V60.5874H385.668V86.8687H408.5ZM353.023 88.8749H315.371L376.656 4.41364H342.608L276.517 93.4892V115.357H352.021V144.848H383.665V115.357H406.497V88.8749H383.665V62.5936H353.023V88.8749ZM142.188 74.6308C142.188 120.974 167.823 147.255 202.271 147.255C236.919 147.255 262.355 120.974 262.355 74.6308C262.355 28.2875 236.919 2.0062 202.271 2.0062C167.823 2.0062 142.188 28.2875 142.188 74.6308ZM229.709 74.6308C229.709 106.529 218.494 119.77 202.271 119.77C186.249 119.77 175.033 106.529 175.033 74.6308C175.033 42.7322 186.249 29.4912 202.271 29.4912C218.494 29.4912 229.709 42.7322 229.709 74.6308Z",
    fill: "#DFCCF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.275,
    y: 78.6401,
    width: 98.1392,
    height: 114.36,
    rx: 3,
    fill: "white",
    stroke: "#250056",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.5 142.5C207 140 196 146.17 196 146.17",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.335 131.808C196.678 131.49 195.897 131.237 195.038 131.065C194.179 130.893 193.258 130.805 192.328 130.805C191.398 130.805 190.478 130.893 189.619 131.065C188.759 131.237 187.979 131.49 187.321 131.808",
    stroke: "#EEEFF3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.367 131.808C219.71 131.49 218.929 131.237 218.07 131.065C217.211 130.893 216.29 130.805 215.36 130.805C214.431 130.805 213.51 130.893 212.651 131.065C211.792 131.237 211.011 131.49 210.354 131.808",
    stroke: "#EEEFF3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.324,
    cy: 124.777,
    r: 3,
    fill: "#250056"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.324,
    cy: 124.777,
    r: 3,
    fill: "#250056"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.203,
    y1: 193,
    x2: 304.486,
    y2: 193,
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.423 55.5719C259.423 57.7912 257.628 59.5874 255.416 59.5874C253.205 59.5874 251.409 57.7912 251.409 55.5719C251.409 53.3526 253.205 51.5564 255.416 51.5564C257.628 51.5564 259.423 53.3526 259.423 55.5719Z",
    stroke: "#9747FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.263 162.402C144.263 163.237 143.588 163.91 142.759 163.91C141.931 163.91 141.256 163.237 141.256 162.402C141.256 161.568 141.931 160.895 142.759 160.895C143.588 160.895 144.263 161.568 144.263 162.402Z",
    stroke: "#9747FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.439 120.773L275.587 120.216L277.643 117.764L278.199 120.917L280.647 122.976L277.499 123.533L275.444 125.986L274.888 122.832L272.439 120.773Z",
    fill: "#3ADEA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.948 45.9053L181.318 41.652L178.875 38.1539L183.121 38.5247L186.613 36.0769L186.243 40.3302L188.686 43.8283L184.44 43.4574L180.948 45.9053Z",
    fill: "#3ADEA2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 163,
    r: 21,
    fill: "#F7F7FA",
    stroke: "#250056",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.698 162.48L245.968 167.215L234.847 169.5",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.69 160.272C269.336 157.095 268.015 154.103 265.904 151.702C263.794 149.301 260.997 147.606 257.892 146.846C254.787 146.087 251.523 146.3 248.543 147.456",
    stroke: "#E6E8EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 271.748,
    y: 175.409,
    width: 23.696,
    height: 4.51919,
    rx: 2.25959,
    transform: "rotate(40.1803 271.748 175.409)",
    stroke: "#250056",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.444 146L241.096 155.404L248.52 156.468L251.77 161.986L258.204 162.908L260.677 166.799",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.c2633369434504ff41dc9c5e617f2ed8.svg";
export { ForwardRef as ReactComponent };